import "./Navbar1.css";

const Navbar1 = () => {
  return (
    <div className="navbar3">
      <div className="title3">
        <div className="heading3">Hello, Raj !</div>
        <div className="sub3">Here’s your dashboard overview.</div>
        <div className="breadcrumbs3">
          <div className="contract12">Contract</div>
          <img className="icon54" alt="" src="/icon-8.svg" />
          <div className="contract13">General Info</div>
          <img className="icon55" alt="" src="/icon-8.svg" />
          <div className="contract14">Scope of Work</div>
          <img className="icon56" alt="" src="/icon-8.svg" />
          <div className="contract15">Payment Details</div>
          <img className="icon57" alt="" src="/icon-8.svg" />
          <div className="general-info3">Sign</div>
        </div>
      </div>
      <div className="right-menu4">
        <div className="button15">
          <img className="icon58" alt="" src="/icon1.svg" />
          <div className="create-a-contract6">SIGNUP/REGISTER</div>
          <img className="icon59" alt="" src="/icon2.svg" />
        </div>
        <div className="icon60">
          <img className="icon61" alt="" src="/icon-13.svg" />
        </div>
        <div className="user3">
          <div className="avatar4">
            <img className="image-icon4" alt="" src="/image@2x.png" />
            <img className="check-icon4" alt="" src="/check.svg" />
          </div>
          <div className="text40">
            <div className="chris-miguel4">Chris Miguel</div>
            <div className="freelancer4">Freelancer</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar1;
